import request from '../http'

/**
 * 获取微信追踪信息 
 * @param {int} qrid 
 * @param {string} track_code 
 * @returns 
 */
export function get_wechat_track_logs_by_track_code(track_code) {
  return request({
    url: `/v1/weixin/logs/track_code/${track_code}`,
    method: 'get'
  })
}

/**
 * 查询当前用户下的所有微信追踪信息
 * @param {int} page 
 * @param {int} num 
 * @returns 
 */
export function get_wechat_track_logs_by_owner(page, num) {
  return request({
    url: `/v1/weixin/logs/page/${page}/num/${num}`,
    method: 'get'
  })
}
